import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs';

function CivilSector() {
//   const page = "civilsector";
  const page = "industry";
  return (
    <div>
        <section className={`hero ${page}`}>
            <h1>Civil Sector</h1>
        </section>

        <Breadcrumbs
            items={[
                { label: "Home", to: "/" },
                { label: "Solutions", to: "/solutions" },
                { label: "Civil-Industry" }, // no `to` = current page
        ]}
        />

        <section className="split-about">
        <div className="split-about__wrap">
            <div className="split-about__content">
            <p>
                Civil engineering is the foundation of modern infrastructure, covering projects such as highways, bridges, tunnels, and water systems. 
                These projects face increasing demands for durability, cost efficiency, and environmental responsibility. Soil stabilization, tunneling, 
                and horizontal directional drilling (HDD) all require materials that can withstand diverse geological conditions while supporting safe and efficient construction. 
                Waterproofing and insulation are equally critical for the longevity of infrastructure assets.
            </p>
            </div>


            <figure className="split-about__media">
            <img src="/assets/images/industry/civil-sector.png" alt="Application film rolls" />
            </figure>

        </div>
        </section>        

        <section className="applications">
        <div className="applications__wrap">
        <h1>Our Solutions:</h1>

            <ul className="applications__list">
            <li><strong>Soil Stabilization & Piling</strong>: MD-BENT and custom blends improve soil binding and ground stability.</li>
            <li><strong>Tunneling & HDD</strong>: Specialized fluids ensure smooth borehole creation and minimize risks.</li>
            <li><strong>Waterproofing & Insulation</strong>: Geosynthetic Clay Liners (GCL) and sealing systems extend infrastructure life.</li>
            </ul>

            <p>
            </p>
        </div>
        </section>        
    </div>
  )
}

export default CivilSector